module.exports = __webpack_public_path__ + "img/xiezhurenyuan.34cb4d99.png";